module.exports = __webpack_public_path__ + "img/unlocked-success.d4cff97b.svg";